import React, { useContext, useRef, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import styles from "./home.module.css";
import { MdOutlineShoppingCart } from "react-icons/md";
import { GrUnorderedList } from "react-icons/gr";
import useDropdownMenu from "react-accessible-dropdown-menu-hook";
import image from "../../assets/images/logo-sabadi.png";
import CartItemsContext from "context/ShoppingCartItems";
import logo from "../../assets/images/logo-sabadi.png";
import { NavLink, Link } from "react-router-dom";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import FastOrderingModal from "components/fastOrdering/fastOrderingModal.jsx";
import "./head.scss";
import Modal from "./Modal";
import SabadKharid from "./SabadKharid";
import ShoppingCart from "components/common/cart/ShoppingCart";
import { connection } from "utils/apiConnection.ts";
import { BiHomeSmile } from "react-icons/bi";
import { FaStoreAlt, FaUserTie } from "react-icons/fa";
import { FiPhoneCall, FiMonitor } from "react-icons/fi";
import { AiOutlineUser } from "react-icons/ai";
import ReactTooltip from "react-tooltip";
import Contact from "../../components/supplier/Contact";
const items = [
  { name: "خانه", to: "/", exact: true },
  // { name: "  پنل کاربری", to: "/customer-panel/profile" },
  { name: " فروشگاه", to: "/shop" },
];

export default function HeaderTest() {
  const collapseRef = useRef(null);
  const auth = useContext(WithAuthentication);
  console.log("auth", auth);
  const hideBars = () => {
    collapseRef.current.setAttribute("class", "navbar-collapse collapse");
  };
  let superAdminAccess = [100, 101, 102, 103, 104, 105, 106, 107, 108];
  const superAdminCheck = () => {
    let result = false;
    for (let i = 0; i < auth.userInfo.access_level.length; i++) {
      if (superAdminAccess.includes(auth.userInfo.access_level[i].code)) {
        result = true;
      }
    }

    return result;
  };
  useEffect(() => {
    console.log("auth1", auth.isLogged);
  }, [auth.isLogged]);
  window.onscroll = () => {
    if (
      !document
        .querySelector(".header-container .navbar-toggler")
        .classList.contains("collapsed")
    ) {
      document
        .querySelector(".header-container .navbar-toggler")
        .classList.add("collapsed");
      document
        .querySelector(".header-container .navbar-collapse")
        .classList.remove("show");
    }
  };
  const { buttonProps, itemProps, isOpen } = useDropdownMenu(5);
  useEffect(() => ReactTooltip.rebuild());
  console.log("jhdkj", superAdminCheck());
  return (
    <>
      <Contact></Contact>
      <FastOrderingModal></FastOrderingModal>
      <div className="sticky-top header-container" style={{ height: 90 }}>
        <nav
          className="navbar navbar-expand-md navbar-light  "
          style={{ backgroundColor: "#ffffff", padding: "1rem 0px" }}
        >
          <div
            className="container-fluid header-item-container"
            style={{ maxWidth: "100% !important", width: "100p%" }}
          >
            <div className="d-flex">
              <button
                className="navbar-toggler me-1 navbarIcon"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbar"
                aria-controls="navbar"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon" />
              </button>
              <div>
                <Link to="/">
                  <img className={styles.sabadilogo} src={logo} alt="" />
                </Link>
              </div>
            </div>
            {/* حالت موبایل */}
            <div className="d-flex d-md-none mobile-menu-container align-items-center">
              <div
                className="login login-button-container"
                style={{
                  borderRadius: "7px",
                  padding: "5px",
                  textAlign: "center",
                }}
              >
                <span className="text-decoration-none text-dark dots-char">
                  {!auth.isLogged ? (
                    <span
                      className=" size1"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      style={{ cursor: "pointer" }}
                    >
                      <AiOutlineUser />
                      {/* <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={16}
                        height={16}
                        fill="currentColor"
                        className="bi bi-person"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                      </svg> */}
                    </span>
                  ) : (
                    <>
                      {superAdminCheck() && (
                        <>
                          <Link
                            to="/super-admin-panel/"
                            data-tip="پنل سوپرادمین"
                            className="text-decoration-none text-dark"
                          >
                            <FiMonitor />
                          </Link>{" "}
                          &nbsp;&nbsp;|&nbsp;&nbsp;
                        </>
                      )}
                      <Link
                        to={`/customer-panel
                      `}
                        className="text-dark text-decoration-none "
                        style={{ fontSize: "14px" }}
                        data-tip="پنل کاربر"
                      >
                        <span className=" size1" style={{ cursor: "pointer" }}>
                          <AiOutlineUser />
                          {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={16}
                            height={16}
                            fill="currentColor"
                            className="bi bi-person"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                          </svg> */}
                        </span>
                        <span className="user-name">
                          {auth.userInfo.fullName.trim() == ""
                            ? "کاربر عزیز"
                            : auth.userInfo.fullName}
                        </span>
                      </Link>
                    </>
                  )}
                  {/* modal */}
                </span>
              </div>
              <div
                style={{ marginLeft: "15px" }}
                data-tip="اطلاعات تماس"
                href="#contact"
                data-bs-toggle="modal"
                data-bs-target="#ModalContact"
              >
                <FiPhoneCall
                  style={{
                    color: "#ff4734",
                    fontSize: "18px",
                    cursor: "pointer",
                  }}
                />
                {/* <ReactTooltip /> */}
              </div>
              {/* <div
                className="login login-button-container mx-2 d-flex align-items-center"
                style={{
                  padding: "0px ",
                  textAlign: "center",
                }}
              >
                <button
                  type="button"
                  class=""
                  style={{ border: "none", background: "none" }}
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModalSabadKharid"
                >
                  <MdOutlineShoppingCart style={{ fontSize: "19px" }} />{" "}
                 
                </button>
              </div> */}
              <SabadKharid />
            </div>
            <div
              className="collapse navbar-collapse "
              id="navbar"
              ref={collapseRef}
            >
              <ul className="navbar-nav ms-0 align-items-center">
                {/* <li
                  style={{ paddingLeft: "10px" }}
                  className="mx-auto p-1 my-1"
                >
                  <button
                    data-bs-toggle="modal"
                    data-bs-target="#fastOrdering"
                    type="button"
                    class="nav-item px-3 py-1 mx-3 text-light "
                    className={styles.btnnav}
                  >
                    <GrUnorderedList
                      style={{ marginLeft: "4px", color: "#ff4734" }}
                    />
                    <span style={{ color: "#ff4734" }}>سفارش</span>
                  </button>
                </li> */}

                {items.map((item) => {
                  return (
                    <li class="nav-item p-1 text-light mx-auto">
                      <NavLink
                        onClick={hideBars}
                        to={item.to}
                        data-toggle="collapse"
                        data-target="#navbarCollapse"
                        className={(navData) =>
                          // navData.isActive ? "activeLink" : "nav-link "
                          navData.isActive ? "" : "nav-link "
                        }
                        exact={item.exact || false}
                      >
                        {item.name == "خانه" ? (
                          <button
                            type="button"
                            class="nav-item px-3 py-1 mx-3 text-light "
                            className={styles.btnnav}
                          >
                            <BiHomeSmile
                              style={{ marginLeft: "4px", color: "#745cfa" }}
                            />
                            <span style={{ color: "#745cfa" }}>
                              {" "}
                              {item.name}
                            </span>
                          </button>
                        ) : (
                          <button
                            type="button"
                            class="nav-item px-3 py-1 mx-3 text-light "
                            className={styles.btnnav}
                          >
                            <FaStoreAlt
                              style={{ marginLeft: "4px", color: "#745cfa" }}
                            />
                            <span style={{ color: "#745cfa" }}>
                              {" "}
                              {item.name}
                            </span>
                          </button>
                        )}
                      </NavLink>
                    </li>
                  );
                })}
              </ul>
              {/* حالت دسکتاپ */}
              <div className="d-none d-md-flex ms-auto d-flex align-items-center">
                <div
                  className="login login-button-container"
                  style={{
                    borderRadius: "7px",
                    padding: "11px",
                    textAlign: "center",
                  }}
                >
                  <span className="text-decoration-none text-dark dots-char d-flex justify-content-end">
                    {!auth.isLogged ? (
                      <span
                        className=" size1"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                        style={{ cursor: "pointer" }}
                      >
                        <AiOutlineUser />
                        {/* <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={16}
                          height={16}
                          fill="currentColor"
                          className="bi bi-person"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                        </svg> */}
                      </span>
                    ) : (
                      <>
                        {superAdminCheck() && (
                          <>
                            <Link
                              to="/super-admin-panel/"
                              data-tip="پنل سوپرادمین"
                              className="text-decoration-none text-dark"
                            >
                              <FiMonitor />
                            </Link>
                            &nbsp;&nbsp;|&nbsp;&nbsp;
                          </>
                        )}
                        <Link
                          to={`/customer-panel
                        `}
                          className={`text-dark text-decoration-none ${styles.txtResHead}`}
                          // style={{ fontSize: "14px" }}
                          data-tip="پنل کاربر"
                        >
                          <AiOutlineUser />
                          {/* <span
                            className=" size1"
                            style={{ cursor: "pointer" }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={16}
                              height={16}
                              fill="currentColor"
                              className="bi bi-person"
                              viewBox="0 0 16 16"
                            >
                              <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                            </svg>
                          </span> */}
                          {auth.userInfo.fullName.trim() == ""
                            ? "کاربر عزیز"
                            : auth.userInfo.fullName}{" "}
                        </Link>
                      </>
                    )}

                    {/* modal */}
                  </span>
                </div>

                <div
                  className="login login-button-container mx-2 d-flex align-items-center"
                  style={{
                    padding: "6px ",
                    textAlign: "center",
                  }}
                >
                  <div
                    className="icon-tel"
                    style={{ marginLeft: "15px" }}
                    data-tip="اطلاعات تماس"
                    href="#contact"
                    data-bs-toggle="modal"
                    data-bs-target="#ModalContact"
                  >
                    <FiPhoneCall
                      style={{
                        color: "#ff4734",
                        fontSize: "21px",
                        cursor: "pointer",
                      }}
                    />
                    <ReactTooltip />
                  </div>
                  <SabadKharid />
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <Modal />
    </>
  );
}
